
import { PPTReport, PPTRulesResponse, } from "../helpers/interfaces";
import { useEffect, useState } from "react";
import React from "react";
import { emptyPPTRulesResponse, FormEditMode, ReportDisplay, ReportType } from "../helpers/constants";
import { getAllPPTReports } from "../apiServices/PPTReportsApi";
import { Box, Button, IconButton, MenuItem, Pagination, Paper, Stack, Table, TableBody, TableHead, Typography, useTheme } from "@mui/material";
import { CustomTextField, StyledTableCell, StyledTableRow } from "../layouts/themes";
import { Add, ArrowBack, RemoveRedEye } from "@mui/icons-material";
import ReportView from "../components/reports/PPTReport";
import { getPPTReports } from "../apiServices/PPTRulesApi";
import CapexReportView from "../components/reports/CAPEXPPTReport";
import { formatShortDateString, getNameFromTotalEnergiesEmail, showAlertMessage } from "../helpers/utils";



const reportTypeOptions = [{ value: ReportType.CAPEX, label: "CAPEX" }, { value: ReportType.OPEX, label: "OPEX" }]


function Reports() {
    const theme = useTheme();
    const [pptReports, setPPTReports] = useState<PPTReport[]>([])
    const [filteredPPTReports, setFilteredPPTReports] = useState<PPTReport[]>([])
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [recordsPerPage, setRecordsPerPage] = useState<number>(15);
    const [numOfPages, setNumOfPages] = useState<number>(0);
    const [currentPageRecords, setCurrentPageRecords] = useState<PPTReport[]>([])
    //const [openPPTReportsForm, setOpenPPTReportsForm] = React.useState(false);
    const [pptReportsEditMode, setPPTReportsEditMode] = React.useState(FormEditMode.CREATE);
    const [pptReportsToEdit, setReportsToEdit] = useState<string>("");

    const [reportDisplay, setReportDisplay] = useState<ReportDisplay>(ReportDisplay.TABLE)

    const [reportType, setReportType] = useState<ReportType>(ReportType.OPEX);
    const [year, setYear] = React.useState<number>(new Date().getFullYear());
    const [pptRulesResponse, setPPTRulesResponse] = useState<PPTRulesResponse>(emptyPPTRulesResponse);

    const [uploadFile, setUploadFile] = useState<File>(new File([], ''));

    async function generateReport() {
        if (!uploadFile || uploadFile.size === 0) {
            alert("Please select an Excel file before generating the report.");
            return;
        }
        try {
            const response = await getPPTReports(reportType, year, uploadFile);
            setPPTRulesResponse(response);
            setReportDisplay(ReportDisplay.VIEW);
            console.log(response, 'report');
        } catch (error) {
            console.error("Error generating report:", error);
            alert("An error occurred while generating the report.");
        }
    }
    const handleopenPPTReportsFormForm = () => {
        setPPTReportsEditMode(FormEditMode.CREATE);
        //setOpenPPTReportsForm(true);
        setReportDisplay(ReportDisplay.FORM)
    };

    useEffect(() => {
        getAllPPTReports().then(reports => setPPTReports(reports))
    }, [])

    useEffect(() => {
        setFilteredPPTReports(pptReports.filter(e =>
            (searchQuery === "" || e.title.toLowerCase().includes(searchQuery.toLowerCase()) || e.subject.toLowerCase().includes(searchQuery.toLowerCase()))
        ));
        setCurrentPage(1);
    }, [searchQuery, pptReports])

    // Calculate number of pages
    useEffect(() => {
        const totalPages = Math.ceil(filteredPPTReports.length / recordsPerPage);
        setNumOfPages(totalPages);

        // If current page exceeds total pages, reset to last valid page
        if (currentPage > totalPages && totalPages > 0) {
            setCurrentPage(totalPages);
        }
    }, [recordsPerPage, filteredPPTReports.length, currentPage]);

    // Calculate current page records
    useEffect(() => {
        const lastIndex = currentPage * recordsPerPage;
        const firstIndex = lastIndex - recordsPerPage;
        setCurrentPageRecords(filteredPPTReports.slice(firstIndex, lastIndex));
    }, [currentPage, recordsPerPage, filteredPPTReports]);

    // Handle pagination change
    const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
    };

    // Handle records per page change
    const handleRecordsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRecordsPerPage = Number(event.target.value);
        setRecordsPerPage(newRecordsPerPage);
        setCurrentPage(1); // Reset to first page when changing records per page
    };
    const handleEdit = (report: PPTReport) => {
        setReportType(report.reportType)
        setReportsToEdit(report.id)
        setYear(Number(report.year))
        setPPTReportsEditMode(FormEditMode.EDIT);
        //setOpenPPTReportsForm(true);
        setReportDisplay(ReportDisplay.VIEW)
    }
    function handleBack() {
        setReportDisplay(ReportDisplay.TABLE)
    }

    return (
        <>
            <Box m="1.0rem 1.0rem">
                <Stack>
                    <Paper>
                        <div className='flex'>
                            {(reportDisplay === ReportDisplay.FORM || reportDisplay === ReportDisplay.VIEW) &&
                                <IconButton className='flex flex-row font-bold' onClick={handleBack}><ArrowBack color='secondary' /> </IconButton>
                            }
                            <Typography fontWeight="bold" sx={{ margin: '1.0rem', color: theme.palette.secondary.main, fontSize: '13px' }}>
                                {(reportDisplay === ReportDisplay.FORM || reportDisplay === ReportDisplay.VIEW) && <span>{reportType}</span>}&nbsp;&nbsp;Report
                            </Typography>
                        </div>

                    </Paper >
                </Stack>
                <Box>

                    {reportDisplay === ReportDisplay.TABLE &&
                        <>
                            <Paper>
                                <Box mt="10px" p='1.0rem' gap="20px">
                                    <div className=" flex flex-row ">
                                        <div className=' flex w-2/3 '>
                                            <CustomTextField size="small" id="outlined-basic" placeholder="Search by Title..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} variant="outlined" sx={{ width: '50%' }} /> &nbsp;

                                        </div>
                                        <div style={{ flexGrow: 1 }} />

                                        <Button color='secondary' variant="contained" style={{ textTransform: 'none', fontSize: 14, }} onClick={handleopenPPTReportsFormForm}><Add />&nbsp;Create Report</Button>
                                    </div>
                                    <br />
                                    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                                        <Table>
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCell> SN</StyledTableCell>
                                                    <StyledTableCell>Title</StyledTableCell>
                                                    <StyledTableCell>Subject </StyledTableCell>
                                                    <StyledTableCell>Generated By</StyledTableCell>
                                                    <StyledTableCell>Year </StyledTableCell>
                                                    <StyledTableCell>Date </StyledTableCell>
                                                    <StyledTableCell>Report Type</StyledTableCell>
                                                    <StyledTableCell>Action</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {currentPageRecords.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).map((item, index) => {
                                                    return <StyledTableRow key={index}>

                                                        <StyledTableCell >
                                                            {index + 1 + ((currentPage - 1) * recordsPerPage)}
                                                        </StyledTableCell>
                                                        <StyledTableCell >{item.title}</StyledTableCell>
                                                        <StyledTableCell >{item.subject}</StyledTableCell>
                                                        <StyledTableCell >{getNameFromTotalEnergiesEmail(item.generatedBy)}</StyledTableCell>
                                                        <StyledTableCell >{item.year}</StyledTableCell>
                                                        <StyledTableCell >{formatShortDateString(item.createdAt, false)}</StyledTableCell>
                                                        <StyledTableCell >{item.reportType}</StyledTableCell>


                                                        <StyledTableCell >

                                                            <Button variant='outlined' color='info' size='small' onClick={() => { handleEdit(item) }}  ><RemoveRedEye />&nbsp; View</Button>&nbsp;&nbsp;&nbsp;&nbsp;

                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                })}

                                                {currentPageRecords.length === 0 &&
                                                    <tr>
                                                        <StyledTableCell colSpan={7}><p style={{ fontSize: '11px', textAlign: 'center' }}>No record available...</p></StyledTableCell>
                                                    </tr>
                                                }
                                            </TableBody>
                                        </Table>
                                    </div>

                                    <br />


                                    <nav>
                                        <div className=" flex flex-row ">
                                            <div className=" flex items-start ">
                                                <div className="px-6 py-2">Rows per page</div>&nbsp;
                                                <div style={{ width: '100px' }}>
                                                    <CustomTextField
                                                        fullWidth
                                                        id="fullWidth"
                                                        select
                                                        variant="outlined"
                                                        size="small"
                                                        name="RequestsNumbers"
                                                        value={recordsPerPage}
                                                        onChange={handleRecordsPerPageChange}
                                                    >
                                                        
                                                        <MenuItem value="15">15</MenuItem>
                                                        <MenuItem value="25">25</MenuItem>
                                                        <MenuItem value="40">40</MenuItem>
                                                        <MenuItem value="55">55</MenuItem>
                                                        <MenuItem value="85">85</MenuItem>
                                                        <MenuItem value="125">125</MenuItem>
                                                        <MenuItem value="200">200</MenuItem>
                                                        <MenuItem value="255">255</MenuItem>
                                                        <MenuItem value="350">350</MenuItem>
                                                        <MenuItem value="500">500</MenuItem>
                                                    </CustomTextField>
                                                </div>
                                            </div>
                                            <div style={{ flexGrow: 1 }} />
                                            {numOfPages > 0 && (
                                                <Stack spacing={2}>
                                                    <Pagination
                                                        count={numOfPages}
                                                        siblingCount={1}
                                                        boundaryCount={1}
                                                        onChange={handlePageChange}
                                                        page={currentPage}
                                                        size="small"
                                                        classes={{ ul: "PaginationUl" }}
                                                        sx={{
                                                            '& .MuiPaginationItem-root': {
                                                                color: '#cc0000',
                                                                '&:hover': {
                                                                    backgroundColor: 'cc0000',
                                                                },
                                                                '&.Mui-selected': {
                                                                    backgroundColor: '#cc0000',
                                                                    color: 'white',
                                                                    '&:hover': {
                                                                        backgroundColor: 'cc0000',
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </Stack>
                                            )}
                                        </div>


                                    </nav>
                                </Box>
                            </Paper>
                        </>
                    }
                    {reportDisplay === ReportDisplay.FORM &&
                        <>
                            <Paper>
                                <Box mt="10px" p='1.0rem' gap="20px">
                                    <form>
                                        <div className='flex flex-row'>
                                            <div className="flex flex-col p-2 w-1/2">
                                                <div >
                                                    <label className='title-label'>Select Report Type<span className='important'>*</span></label>
                                                </div>
                                                <div >
                                                    <div className="form-group mb-0">
                                                        <div className="">
                                                            <CustomTextField fullWidth size="small" select variant="outlined" id="reportType" value={reportType} onChange={(e) => setReportType(e.target.value as ReportType)} >
                                                                {reportTypeOptions.map((report, index) => {
                                                                    return <MenuItem key={index} value={report.value}>{report.label}</MenuItem >
                                                                })}
                                                            </CustomTextField>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />

                                            <div className='flex flex-col p-2 w-1/2'>
                                                <div >
                                                    <div >
                                                        <label className=' title-label'>Year </label>
                                                    </div>
                                                    <div className=''>
                                                        <CustomTextField type='number' fullWidth size="small" id='year' placeholder="Year" value={year} onChange={(e) => setYear(Number(e.target.value))} />
                                                    </div>
                                                </div>


                                            </div>
                                            &nbsp;&nbsp;&nbsp;
                                        </div>
                                        <div className="p-2">
                                            <p style={{ fontSize: 13, marginBottom: 6 }}>
                                                Please select an Excel file to import PPT Filing for the year <b>{year}</b>.
                                            </p>

                                            {/* ✅ Expected file name format */}
                                            <p
                                                style={{
                                                    fontSize: 12,
                                                    background: "#f5f5f5",
                                                    border: "1px dashed #ccc",
                                                    padding: "6px 10px",
                                                    borderRadius: 6,
                                                    marginBottom: 12,
                                                    color: "#555",
                                                }}
                                            >
                                                <b>Expected file name:</b> <br />
                                                <code>PPT_PPT-{year}-MM-DD.xlsx</code>
                                            </p>

                                            <Button
                                                variant="contained"
                                                component="label"
                                                color="info"
                                                fullWidth
                                                sx={{ mt: 1, width: '300px' }}
                                            >
                                                Choose Excel File (.xlsx)
                                                <input
                                                    hidden
                                                    type="file"
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                    onChange={(e) => {
                                                        if (e.target.files && e.target.files.length > 0) {
                                                            const file = e.target.files[0];
                                                            const fileName = file.name;

                                                            // ✅ Correct filename pattern: PPT_PPT-YYYY-MM-DD.xlsx
                                                            const match = fileName.match(/^PPT_PPT-(\d{4})-(\d{2})-(\d{2})\.xlsx$/i);
                                                            if (!match) {
                                                                showAlertMessage("⚠️ Invalid file name format. Expected: PPT_PPT-YYYY-MM-DD.xlsx");
                                                                e.target.value = "";
                                                                return;
                                                            }

                                                            // ✅ Check year consistency
                                                            const fileYear = Number(match[1]);
                                                            if (fileYear !== year) {
                                                                showAlertMessage(`⚠️ The file year (${fileYear}) does not match the selected year (${year}).`);
                                                                e.target.value = "";
                                                                return;
                                                            }

                                                            setUploadFile(file);
                                                        }
                                                    }}
                                                />
                                            </Button>
                                        </div>

                                        <br />
                                        {uploadFile.size > 0 &&
                                            <div

                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "8px",
                                                    padding: "8px 12px",
                                                    marginTop: "2px",
                                                }}
                                            >
                                                <span>{uploadFile.name}</span>
                                                <button
                                                    style={{
                                                        marginBottom: '4px',
                                                        background: "none",
                                                        border: "none",
                                                        fontSize: "16px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                        setUploadFile(new File([], ''));
                                                    }}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        }

                                        <div className="mt-4" style={{ float: 'right' }}>

                                            <Button color='secondary' variant="contained" style={{ textTransform: 'none', fontSize: 14, }} onClick={generateReport}><Add />&nbsp;Generate Report </Button>
                                        </div>
                                        <br />
                                        <br />
                                    </form >
                                </Box>
                            </Paper>
                        </>
                    }
                    {(reportType === ReportType.OPEX && reportDisplay === ReportDisplay.VIEW) &&

                        <ReportView year={year} setPPTReportsEditMode={setPPTReportsEditMode} pptReports={pptReports} setPPTReports={setPPTReports} pptReportsEditMode={pptReportsEditMode} pptReportsToEdit={pptReportsToEdit} pptRulesResponse={pptRulesResponse} reportDisplay={reportDisplay} setReportDisplay={setReportDisplay} reportType={reportType} />
                    }
                    {(reportType === ReportType.CAPEX && reportDisplay === ReportDisplay.VIEW) &&

                        <CapexReportView year={year} setPPTReportsEditMode={setPPTReportsEditMode} pptReports={pptReports} setPPTReports={setPPTReports} pptReportsEditMode={pptReportsEditMode} pptReportsToEdit={pptReportsToEdit} pptRulesResponse={pptRulesResponse} reportDisplay={reportDisplay} setReportDisplay={setReportDisplay} reportType={reportType} />
                    }

                </Box>
            </Box>

        </>
    )
}
export default Reports;